let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");

let DaModal = dd.createClass({
	mixins: [RadioServiceMixin],
	RadioService_setup(){
		return {
			Event_update_children_status: {
				key: "callService",
				on: {
					succeeded(){
						this.props.onClose();
					}
				}
			}
		};
	},
	__doIt: esUtils.wrapPreventDefault(function(){
		this.RadioService_callService("Event_update_children_status", {
			eid: this.props.event.eid,
			status: this.props.event.status,
			applyactionlist: true,
		});
	}),
	render(){
		let {event, onClose} = this.props;
		let ajax = this.state.Event_update_children_status;

		if(ajax.waiting){
			return dd.span();//silently work, i.e. we don't need to show a loading bar b/c most of the time this will just work in the background
		}
		return Modal({
				title: "Update child event status?",
				buttons: [
					{
						name: "Nope",
						onClick: onClose,
						className: "btn btn-default"
					},
					{
						name: "Update Children",
						onClick: this.__doIt,
						className: "btn btn-primary"
					}
				],
				onClose
			},
			ErrorAlert({message: ajax.error}),
			dd.p(null,
				"Would you like to update the status of these child events? This will also add anything on their Action Lists that applies to the new status."
			),
			dd.ul(null,
				_.map(event.childevents, function(child){
					return dd.li({key: child.id}, child.organization);
				})
			)
		);
	}
});

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState(){
		return {event: null};
	},
	Radio_setup(){
		return {
			event_offer_to_update_children_status(event){
				if(_.isEmpty(event && event.childevents)){
					return;
				}
				this.setState({event});
			}
		};
	},
	__close: esUtils.wrapPreventDefault(function(){
		this.setState({event: null});
	}),
	render(){
		let {event} = this.state;
		if(_.isEmpty(event && event.childevents)){
			return dd.span();
		}
		return DaModal({event, onClose: this.__close});
	}
});



// WEBPACK FOOTER //
// ./src/components/modals/PromptToChangeStatusForChildren.js